import React from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { trackTelemetryEvent } from "../telemetry";

const PUBLIC_MENU_PATH = /^\/establishment\/view\/([^/?#]+)/i;

export default function PoweredByPlatGrowth({ user = null }) {
  const location = useLocation();
  const match = location.pathname.match(PUBLIC_MENU_PATH);

  if (!match) return null;

  const slug = decodeURIComponent(match[1] || "").trim();
  const query = new URLSearchParams({
    source: "powered-by-plat",
    ref: slug,
    utm_source: "public_menu",
    utm_medium: "product_badge",
    utm_campaign: "powered_by_plat",
  });
  const destination = user
    ? `/establishment/create?${query.toString()}`
    : `/register?${query.toString()}`;

  const referralQuery = new URLSearchParams({
    source: "powered-by-plat-referral",
    ref: slug,
    utm_source: "public_menu",
    utm_medium: "whatsapp_referral",
    utm_campaign: "powered_by_plat_referral",
  });
  const referralUrl = `https://plat.petertecnet.com.br/register?${referralQuery.toString()}`;
  const referralMessage = encodeURIComponent(
    `Conheça a Plat: cardápio digital, QR Code e pedidos online para bares, restaurantes e outros negócios. ${referralUrl}`
  );
  const whatsappReferralUrl = `https://wa.me/?text=${referralMessage}`;

  const handleConversion = () => {
    trackTelemetryEvent("plat_powered_by_referral_clicked", {
      target: destination,
      label: "Criar meu cardápio",
      metadata: {
        placement: "public_menu",
        destination: user ? "/establishment/create" : "/register",
        source: "powered-by-plat",
        ref: slug || null,
        utm_source: "public_menu",
        utm_medium: "product_badge",
        utm_campaign: "powered_by_plat",
        authenticated: Boolean(user),
      },
    });
  };

  const handleWhatsappReferral = () => {
    trackTelemetryEvent("plat_powered_by_whatsapp_referral_clicked", {
      target: referralUrl,
      label: "Indicar a Plat",
      metadata: {
        placement: "public_menu",
        destination: "/register",
        source: "powered-by-plat-referral",
        ref: slug || null,
        utm_source: "public_menu",
        utm_medium: "whatsapp_referral",
        utm_campaign: "powered_by_plat_referral",
        authenticated: Boolean(user),
      },
    });
  };

  return (
    <aside
      aria-label="Criar cardápio digital com a Plat"
      style={{
        width: "min(1380px, calc(100% - 28px))",
        margin: "18px auto 110px",
        padding: "14px 16px",
        border: "1px solid rgba(239,216,157,.24)",
        borderRadius: 16,
        background: "rgba(13,17,23,.82)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        display: "flex",
        gap: 14,
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <div style={{ minWidth: 220, flex: "1 1 360px" }}>
        <strong style={{ display: "block", color: "#f4e4b7", fontSize: 14 }}>
          Powered by Plat
        </strong>
        <span style={{ color: "#aeb7c4", fontSize: 13 }}>
          Tem um bar, restaurante ou negócio? Crie seu cardápio digital e comece a receber pedidos online.
        </span>
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
        <a
          href={whatsappReferralUrl}
          target="_blank"
          rel="noreferrer"
          onClick={handleWhatsappReferral}
          style={{
            textDecoration: "none",
            fontWeight: 800,
            fontSize: 13,
            color: "#f4e4b7",
            border: "1px solid rgba(239,216,157,.38)",
            borderRadius: 999,
            padding: "10px 15px",
            whiteSpace: "nowrap",
          }}
        >
          Indicar a Plat
        </a>
        <Link
          to={destination}
          onClick={handleConversion}
          style={{
            textDecoration: "none",
            fontWeight: 800,
            fontSize: 13,
            color: "#11151b",
            background: "#efd89d",
            borderRadius: 999,
            padding: "10px 15px",
            whiteSpace: "nowrap",
          }}
        >
          Criar meu cardápio
        </Link>
      </div>
    </aside>
  );
}

PoweredByPlatGrowth.propTypes = {
  user: PropTypes.object,
};
